/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logout': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M888 64H136c-39.7 0-72 32.3-72 72v752c0 39.7 32.3 72 72 72h752c39.7 0 72-32.3 72-72V136c0-39.7-32.3-72-72-72zM553.4 701.5c-7 7-16.2 10.5-25.5 10.5s-18.4-3.5-25.5-10.5c-14.1-14.1-14.1-36.9 0-50.9L605.1 548H332c-19.9 0-36-16.1-36-36s16.1-36 36-36h273.1L502.5 373.4c-14.1-14.1-14.1-36.9 0-50.9 14.1-14.1 36.9-14.1 50.9 0L742.9 512 553.4 701.5z"/>'
  }
})
